'use client';
import { usePathname } from 'next/navigation';
import { routing } from '../i18n/routing';

/**
 * A hook to get the current path without the locale
 */
export function usePath(): string {
    const fullPath = usePathname();

    const localePrefix = routing.locales.find(
        (locale) => fullPath === `/${locale}` || fullPath.startsWith(`/${locale}/`)
    );

    if (localePrefix) {
        // remove locale from path
        return fullPath === `/${localePrefix}` ? '/' : fullPath.substring(localePrefix.length + 1);
    }
    return fullPath;
}
